import React from 'react';
import { TelemetryContext } from '../../@vendor/Posthog';
import { BoardInfo } from './BoardInfo';
import { useEditorSessionObserver } from './EditorSession';

export const EditorTelemetryContext = ({ children }: { children: React.ReactNode }) => {
    const board = useEditorSessionObserver(BoardInfo);
    return <TelemetryContext boardId={board.id}>
        {children}
    </TelemetryContext>;
};

